import gqlTagGira from 'graphql-tag';

export const ISSUES_QUERY_BY_JQL = gqlTagGira`
    query jira_cycleTimeReport_issuesQueryByJql_Query($jql: String, $first: Int!, $after: String){
      issues(first: $first, jql: $jql, after: $after) {
        nodes {
          id
          issueId
          issuekey {
            stringValue
          }
          summary {
            textValue
          }
          issuetype {
            iconUrl
          }
        }
        pageInfo {
            hasNextPage
            endCursor
        }
      } 
    }
`;
